// AG Grid picks row and header heights for touch vs pointer at grid creation, so a
// phone that rotates keeps the heights of the previous orientation (rows drawn 40px
// tall but positioned 20px apart). Kept in its own module so the maths and the
// preserve-dragged-rows ordering can be checked without a browser — see
// rowheight.selfcheck.mjs.

export const TOUCH_MAX_WIDTH = 768;

export const isTouchSized = (width) => width <= TOUCH_MAX_WIDTH;
export const headerHeightFor = (width) => (isTouchSized(width) ? 35 : 27);
export const rowHeightFor = (width) => (isTouchSized(width) ? 40 : 20);

// Returns false when the grid is gone, so callers can drop it from their registry.
export function applyViewportRowHeights(gridApi, width) {
  if (!gridApi || gridApi.isDestroyed?.()) return false;

  // Read the dragged heights first: changing the rowHeight option already re-measures
  // rows, so capturing afterwards records the new default and "restores" that instead.
  const dragged = [];
  gridApi.forEachNode?.((node) => {
    if (node.__smaacManualRowHeight) dragged.push([node, node.rowHeight]);
  });

  gridApi.setGridOption('headerHeight', headerHeightFor(width));
  gridApi.setGridOption('rowHeight', rowHeightFor(width));
  // resetRowHeights() drops every explicit height, including the ones the user dragged
  // out via bindManualRowResize, so put those back afterwards.
  gridApi.resetRowHeights?.();
  dragged.forEach(([node, height]) => node.setRowHeight(height));
  if (dragged.length) gridApi.onRowHeightChanged?.();
  return true;
}
